// extracted by mini-css-extract-plugin
module.exports = {"whatToLookIcon":"styles_whatToLookIcon__3eYrY"};